module.exports = __webpack_public_path__ + "img/airplane_mobile_low.6df330a2.jpg";